import React from 'react'
import { DialogActions } from '@mui/material';
import PrimaryButton from '../button/PrimaryButton';
import SecondaryButton from '../button/SecondaryButton';

const DialogFooter = (props) => {
  return (
    <DialogActions className='dialog-footer justify-between'>
      {props.customFooter ?
        props.customFooter
        :
        (
          <React.Fragment>
            <SecondaryButton
              id = 'dialog-secondary-btn'
              text={props.secondaryButton.text}
              onClick={props.secondaryButton.onClick ? props.secondaryButton.onClick : props.onClose}
              isDisabled={props.secondaryButton.isDisabled}
            />

            <PrimaryButton
              id = 'dialog-primary-btn'
              text={props.primaryButton.text}
              onClick={props.onSubmit}
              isDisabled={props.primaryButton.isDisabled}
            />
          </React.Fragment>
        )}
    </DialogActions>
  )
}

export default DialogFooter;
